import $ from 'jquery';

export {$ as $};
export var $win = $(window);
export var $doc = $(document);
export var $html = $('html');
export var $body = $('body');
